<template>
  <div class="order-confirm-body" @click="oil_pup_show=false">
    <div class="order-confirm-nav">
      <navbar title="订单确认" :lefticonshow="true" :lefticonwidth="9" :lefticonheight='16' :lefticon="newoilcardbackicon" @goback="goBack"></navbar>
    </div>
    <!-- chinapetroleumbindlogo -->
    <div class="order-confirm-logo" :class="{'petroleum-logo':oil_type !== 'sinopec'}"><img :src="oil_type == 'sinopec' ? chinasinopecbindlogo : chinapetroleumbindlogo" alt=""></div>
    <div class="order-confirm-title">{{oil_type == "sinopec" ?'中国石化':'中国石油'}}加油卡充值业务</div>
    <div class="order-confirm-price">¥{{Number(charge_amount_coin).toFixed(2)}}</div>
    <div class="order-info-div">
      <div class="order-info-item"><span>卡号信息</span><span>{{HandlecardNumber(charge_account)}}</span></div>
      <div class="order-info-item"><span>油卡类型</span><span>{{oil_type == "sinopec" ?'中国石化':'中国石油'}}</span></div>
    </div>
    <div class="order-detail-div">
      <div class="order-detail-title">
        <div>支付明细</div>
        <div @click.stop="oil_pup_show=!oil_pup_show" class="order-server-charge-des">
          <img :src="newoilinfoicon" alt=""><span>服务费说明</span>
          <!-- <div class="oil-pup-mask" v-show="oil_pup_show" @click="oil_pup_show=false" @touchmove.prevent> -->
          <!-- </div> -->
          <div class="oil-pup-con" v-show="oil_pup_show">
            <div>服务费说明</div>
            <div>
              <p v-for="(item,index) in service_charge_descriptions" :key="index">{{item}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="order-detail-item" :class="{'item-red':used_coin!='0.00'}"><span>红包抵扣金额</span><span><span v-show="used_coin!='0.00'">-</span>{{used_coin}}元</span></div> -->
      <div class="order-detail-item"><span>到账金额</span><span>{{get_price}}元</span></div>
      <div class="order-detail-item"><span>缴纳单位收费</span><span>{{charge_amount}}元</span></div>
      <!-- <div class="order-detail-item"><span>技术服务费比例</span><span>{{service_fee_ratio}}%</span></div> -->
      <div class="order-detail-item"><span>服务费</span><span>{{service_fee_amount}}元</span></div>
      <div class="order-detail-item"><span>支付金额</span><span>{{Number(charge_amount_coin).toFixed(2)}}元</span></div>
      <div class="order-detail-item"><span>应该返还积分</span><span class="red-span">{{handsel_coin}}积分</span></div>
      <!-- <div class="order-detail-check-div" v-if="!disabled">
        <div class="order-detail-check-left">
          <div>使用红包抵扣（红包剩余{{all_coin}}）</div>
          <div>勾选后，支付将优先使用红包抵扣</div>
          <div @click.stop="goPage('/new-oli/rechargeAgreement')">《个人红包使用规则》</div>
        </div>
        <div class="order-detail-check-right">
          <van-checkbox v-model="checked" :disabled="disabled" @change="changeCoin" />
        </div>
      </div> -->
    </div>
    <div class="apply-btn" @click="oilPay"><span>去支付</span></div>
    <van-dialog v-model="dialog_show" :message="dialogMessage" confirm-button-text="去处理" confirm-button-color="#F9591B" cancel-button-text="取消" cancel-button-color="#999999" @confirm="ialogConfirm" @cancel="goBack" show-cancel-button></van-dialog>
    <centerrscreenloading :loading="page_loading" :text="loading_text" />
  </div>
</template>

<script>
  import navbar from '../components/nav-bar.vue'
  import centerrscreenloading from '../components/centerrscreen-loading.vue'
  import dsbridge from "dsbridge";
  import { getThirdrechargeOilCoinInfo, getAppCreditsInfo, getThirdrechargeOilOrderConfirm, getThirdrechargeOilCardService, memberOrderCreate, getThirdrechargeOilChargeDescription, getThirdrechargeOilCardPrice } from '../api/index'
  import { Toast } from 'vant';
  export default {
    components: {
      navbar,
      centerrscreenloading
    },
    data () {
      return {
        newoilcardbackicon: require('@/assets/recharge/new-oilcard-back-icon.png'),
        chinapetroleumbindlogo: require('@/assets/recharge/china-petroleum-bind-logo.png'),
        chinasinopecbindlogo: require('@/assets/recharge/china-sinopec-bind-logo.png'),
        newoilinfoicon: require('@/assets/recharge/new-oil-info-icon.png'),
        tag_index: 0,
        more_control_show: false,
        untiePupShow: false,
        checked: false,
        oil_pup_show: false,
        card_index: 0,
        charge_id: '',
        channel_id: '',
        charge_amount: 0,
        goods_id: '',
        item_id: '',
        charge_account: '',
        oil_type: '',
        deduct_coin: '0.00', // 红包抵扣金额
        used_coin: '0.00', // 显示的红包抵扣金额
        disabled: true,
        charge_amount_coin: 0,
        all_coin: '', // 剩余红包金额
        service_fee_ratio: '',
        service_fee_amount: 0, // 技术服务费
        handsel_coin: 0,
        service_charge_descriptions: "",
        get_price: '',
        page_loading: true,
        loading_text: '加载中...',
        dialog_show: false,
        dialogMessage: "",
      }
    },
    async created () {
      window.setPay = this.setPay
      this.charge_id = this.$route.query.charge_id
      this.channel_id = this.$route.query.channel_id
      this.charge_amount = this.$route.query.charge_amount
      this.goods_id = this.$route.query.goods_id
      this.charge_account = this.$route.query.charge_account
      this.oil_type = this.$route.query.oil_type
      this.item_id = this.$route.query.item_id
      await this.getOrderInit()

      getThirdrechargeOilChargeDescription({ "charge_id": "14", "channel_id": "8" }).then((res) => {
        for (let item of res.data) {
          if (item.title == "服务费说明") {
            this.service_charge_descriptions = item.description.split("\n").map((item) => `${item}`);
          }
        }
        this.page_loading = false
      })
    },
    methods: {
      /**
       * @author: shiao
       * @description: 订单信息初始化
       * @return {void}
       */
      async getOrderInit () {
        await getThirdrechargeOilCardPrice({ item_id: this.item_id, charge_id: this.charge_id, channel_id: this.channel_id }).then((res) => {
          this.get_price = res.list
        })
        await getThirdrechargeOilCardService().then((res) => {
          this.service_fee_ratio = res.list
          this.service_fee_amount = (Number(this.service_fee_ratio) * this.charge_amount * 0.01).toFixed(2)
          this.charge_amount_coin = Number(this.charge_amount) + Number(this.service_fee_amount)
          this.handsel_coin = ((Number(this.service_fee_ratio) + 100) * this.charge_amount * 0.01).toFixed(2)
        })
        // await this.getUserCoin()
      },
      /**
       * @author: shiao
       * @description: 获取用户红包相关数据
       * @return {void}
       */
      async getUserCoin () {
        const credits_info = await getAppCreditsInfo({ creditsId: sessionStorage.getItem('oilcredits_id') })
        await getThirdrechargeOilCoinInfo({
          "orderAmount": Number(this.charge_amount_coin).toFixed(2),
          "orderType": "thirdoil"
        }).then((res) => {
          if (res.reserveCoinAmount !== 0 && !(res.nowCoin < 100 && credits_info.nowBalance >= 5000)) {
            const all_coin_list = String(res.nowCoin).split('.')
            this.all_coin = all_coin_list.length != 1 ? (all_coin_list[0] + '.' + all_coin_list[1].slice(0, 2)) : all_coin_list[0] + '.00'
            this.deduct_coin = res.reserveCoinAmount
            this.disabled = false
          } else {
            this.disabled = true
          }
        })
      },
      floatNumPoint (num, point_num = 2) {
        const num_list = String(num).split('.')
        let new_num = ''
        if (num_list.length == 2) {
          new_num = num_list[0] + '.' + (num_list[1].slice(0, point_num).length == point_num ? num_list[1].slice(0, point_num) : num_list[1].slice(0, point_num) + '0') // 通用方法，这里有点问题
        } else {
          new_num = num_list[0] + '.00'
        }
        return new_num
      },
      changeCardIndex (index) {
        this.card_index = index
      },
      HandlecardNumber (number) {
        let new_number = ''
        for (let index in number) {
          new_number += number[index]
          if (index % 4 == 3) {
            new_number += ' '
          }
        }
        return new_number
      },
      changeCoin () {
        if (this.checked) {
          this.charge_amount_coin = Number(this.charge_amount_coin) - Number(this.deduct_coin)
          this.all_coin = this.floatNumPoint((Number(this.all_coin) - Number(this.deduct_coin)))
          this.used_coin = this.deduct_coin
        } else {
          this.charge_amount_coin = Number(this.charge_amount_coin) + Number(this.deduct_coin)
          this.all_coin = this.floatNumPoint((Number(this.all_coin) + Number(this.deduct_coin)))
          this.used_coin = '0.00'
        }
      },
      oilPay () {
        if (this.iscalled) return
        this.iscalled = true
        this.page_loading = true
        this.loading_text = '支付中...'
        getThirdrechargeOilOrderConfirm({
          "order": { //类型：Object  必有字段  备注：无
            "type": "thirdoil", //类型：String  必有字段  备注：充值类型
          },
          "charge_id": this.charge_id, //类型：String  必有字段  备注：charge_id
          "channel_id": this.channel_id, //类型：String  必有字段  备注：channel_id
          "goods_id": this.goods_id, //类型：String  必有字段  备注：面额id
          "charge_account": this.charge_account, //类型：String  必有字段  备注：油卡账号
          "charge_amount": this.charge_amount, //类型：String  必有字段  备注：充值金额
          // "is_use_deduct_credit2": this.checked ? 1 : 0, //类型：String  必有字段  备注：是否使用红包（1为使用，0为未使用）
          "deduct_coin": this.deduct_coin // 红包抵扣金额
        }).then((res) => {
          this.createOrder(res.order.confirm)
        }).catch(async (err) => {
          this.iscalled = false
          if (err.code == 242206) {
            this.page_loading = false
            this.dialogMessage = err.message
            this.dialog_show = true
            return
          }
          if ([220412, 249702, 249707].includes(err.code)) { // 红包出现错误重新计算
            this.checked = false
            this.used_coin = '0.00'
            // await this.getOrderInit()
            this.iscalled = false
            this.page_loading = false
            Toast(err.message)
            return
          }
          this.page_loading = false
          Toast(err.message)
        })
      },
      createOrder (confirm) {
        memberOrderCreate({
          order: { //类型：Object  必有字段  备注：主订单默认参数
            type: "thirdoil",
            client: 10,
            confirm: confirm
          },
          "charge_id": this.charge_id, //类型：String  必有字段  备注：charge_id
          "channel_id": this.channel_id, //类型：String  必有字段  备注：channel_id
          "goods_id": this.goods_id, //类型：String  必有字段  备注：面额id
          "charge_account": this.charge_account, //类型：String  必有字段  备注：油卡账号
          "charge_amount": this.charge_amount, //类型：String  必有字段  备注：充值金额
          // is_use_deduct_credit2: this.checked ? 1 : 0, //类型：Number  必有字段  备注：是否红包支付，1是，0否
          order_amount: confirm[0].order_amount,
          deduct_coin: confirm[0].deduct_coin,
          id_card_number: this.$route.query.id_card_number,
          name: this.$route.query.name
        }).then(res => {
          this.loading = false;
          // if (res.code == 921212 || res.code == 220503 || res.code == 220410 || res.code == 150006) {
          //   Toast(res.message)
          //   return
          // }
          const param = {
            actual_amount: res.actual_amount,
            order_amount: res.order_amount,
            ordersn: res.ordersn,
            order_type: 'general_pay'
          }
          var u = navigator.userAgent;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || /iphone|ipad|ipod|macintosh/gi.test(u); //ios终端
          if (isIOS) {
            let that = this;
            dsbridge.call("goPay", JSON.stringify(param), function(v) {
              that.setPay(v)
            })
          } else if (isAndroid) {
            this.params(JSON.stringify(param), JSON.stringify(param), 'goPay')
          }
          this.iscalled = false
          this.page_loading = false
        }).catch((err) => {
          Toast(err.message)
        })
      },
      // 原生支付后的回调
      setPay () {
        this.$router.replace({
          path: '/recharge/myOrder'
        })
      },
      ialogConfirm () {
        this.$router.replace('/recharge/myOrder')
      },
      goPage (path) {
        const item = {}
        if (path == '/new-oli/rechargeAgreement') {
          item.number = 'GRHB'
          item.title = '个人红包使用规则'
        }
        this.$router.push({
          path,
          query: item
        })
      },
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>
<style lang="less">
  .order-confirm-body {

    .order-detail-check-right {
      display: flex;

      .van-checkbox {
        align-items: center;

        div {
          background-color: #fff;
          border-radius: 50%;
        }

        .van-checkbox__icon {
          height: 14px;
        }

        .van-icon {
          border: none;
          width: 14px;
          height: 14px;
        }

        .van-checkbox__icon--checked .van-icon {
          background: #f9591b;
          border-color: #f9591b;

          &::before {
            width: 14px;
            height: 14px;
            position: relative;
            top: -3px;
          }
        }
      }

    }
  }
</style>
<style lang="less" scoped>
  .order-confirm-body {
    min-height: calc(100vh - 88px);
    padding-top: 88px;
    overflow: hidden;

    .order-confirm-nav {
      padding-top: 44px;
      position: fixed;
      top: 0;
      left: 0;
      background-color: #fff;
      z-index: 9;

      .oil-card-tag-div {
        height: 44px;
        display: flex;

        .oil-tag-item {
          flex: 1;
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 44px;
          text-align: center;
        }

        .oil-tag-actiave {
          color: #F9720E;
          position: relative;

          &::after {
            content: '';
            width: 84px;
            height: 4px;
            background: linear-gradient(135deg, #f9750d, #f44e19);
            border-radius: 2px;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
          }
        }
      }
    }

    .order-confirm-logo {
      text-align: center;

      img {
        width: 42px;
        height: 46px;
        margin: 40px auto 10px;
      }
    }

    .petroleum-logo {
      img {
        width: 46px;
      }
    }

    .order-confirm-title {
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 22px;
    }

    .order-confirm-price {
      font-size: 26px;
      font-weight: 600;
      text-align: center;
      color: #333333;
      line-height: 31px;
      margin: 18px 16px 0;
      border-bottom: 1px solid rgba(151, 151, 151, 0.2);
      padding-bottom: 59px;
    }

    .order-info-div {
      padding: 16px 8px;
      border-bottom: 1px solid rgba(151, 151, 151, 0.2);
      margin: 0 16px;

      .order-info-item {
        display: flex;

        span {
          &:first-child {
            white-space: nowrap;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #7f7f7f;
            line-height: 20px;
            margin-bottom: 6px;
          }

          &:last-child {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #000000;
            line-height: 20px;
            margin-left: 21px;
          }
        }
      }
    }

    .order-detail-div {
      padding: 16px 24px 31px;

      .order-detail-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        position: relative;

        div {
          &:first-child {
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            color: #333333;
            line-height: 20px;
          }

          &:last-child {
            img {
              width: 12px;
              height: 12px;
              position: relative;
              top: 4px;
              right: 4px;
              vertical-align: top;
            }

            span {
              display: inline-block;
              font-size: 14px;
              font-weight: 400;
              text-align: right;
              color: #333333;
              line-height: 20px;
            }
          }
        }
      }

      .order-detail-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;

        span {
          font-size: 14px;
          font-weight: 400;
          color: #7f7f7f;
          line-height: 20px;

          &:last-child {
            text-align: left;
          }

          &:last-child {
            text-align: right;
            color: #000000;
          }
        }

        .red-span {
          color: #FA750D !important;
        }
      }

      .order-detail-check-div {
        height: 52px;
        background: #ffe7dd;
        border-radius: 6px;
        box-shadow: 0px 2px 4px 0px rgba(255, 219, 203, 0.24);
        width: calc(100vw - 64px);
        padding: 12px 8px;
        display: flex;
        justify-content: space-between;

        .order-detail-check-left {
          div {
            &:first-child {
              font-size: 12px;
              font-weight: 500;
              text-align: left;
              color: #f45018;
              line-height: 17px;
            }

            &:nth-child(2),
            &:nth-child(3) {
              font-size: 8px;
              font-weight: 400;
              text-align: left;
              color: #f55217;
              line-height: 17px;
              margin-top: 2px;
            }

            &:nth-child(3) {
              text-decoration: underline;
            }
          }
        }

        .order-detail-check-right {
          display: flex;

          .van-checkbox {
            align-items: center;

            div {
              background-color: #fff;
            }
          }
        }
      }

    }

    .item-red {
      span {
        color: #f55019 !important;
      }
    }

    .apply-btn {
      height: 25px;
      background: linear-gradient(135deg, #fa770d, #f44d19);
      border-radius: 25px;
      width: calc(100% - 30px);
      text-align: center;
      padding: 10px 0;
      margin: 0 15px 9px;

      span {
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 25px;
      }
    }

    .order-server-charge-des {
      // position: relative;

      .oil-pup-con {
        opacity: 0.8;
        background: #000000;
        border-radius: 20px;
        width: calc(100vw - 32px);
        position: absolute;
        z-index: 2;
        top: 25px;
        left: 50%;
        transform: translate(-50%, 0);
        padding: 10px 0;

        div {
          &:nth-child(1) {
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 20px;
            text-align: center;
            margin: 0 0 10px;
          }

          &:nth-child(2) {
            padding: 0 21px;
            max-height: 23vh;
            overflow-y: auto;

            P {
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #ffffff;
              line-height: 20px;
              margin-bottom: 4px;
            }
          }
        }
      }

      // .oil-pup-mask {
      //   position: fixed;
      //   width: 100vw;
      //   height: 100vh;
      //   left: 0;
      //   top: 0;
      //   right: 0;
      //   bottom: 0;
      //   z-index: 2;

      // }
    }

    .bm34 {
      bottom: 67px;
    }
  }
</style>